import React from 'react';
import { Card, CardContent, Typography, Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, Divider } from '@mui/material';
import styles from './NewCandidates.module.scss';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'; // Generic person icon
import {NewCandidatesProps} from "../../types/types";
import dayjs from 'dayjs';


const NewCandidates: React.FC<NewCandidatesProps> = ({candidates}) => {
  return (
    <Card className={styles.card}>
      <CardContent>
        <Typography variant="h6" className={styles.title} sx={{ color: 'var(--mui-palette-text-primary)' }}>
          New Applicants
        </Typography>
        <Typography variant="body2" className={styles.subtitle} sx={{ color: 'var(--mui-palette-text-secondary)' }}>
          Applicants who applied in {dayjs().format("MMMM")}
        </Typography>
        <List className={styles.candidateList}>
          {candidates.map((candidate, index) => (
            <React.Fragment key={candidate.id}>
              <ListItem alignItems="flex-start" className={styles.listItem}>
                <ListItemAvatar className={styles.listItemAvatar}>
                  <Avatar alt={candidate.name} src={candidate.avatar} className={styles.avatar}>
                    {!candidate.avatar && <PersonOutlineIcon />}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText className={styles.listItemContent}
                  primary={
                    <Typography variant="subtitle1" className={styles.candidateName} sx={{ color: 'var(--mui-palette-text-primary)' }}>
                      {candidate.name}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" className={styles.candidateEmail} sx={{ color: 'var(--mui-palette-text-secondary)' }}>
                      {candidate.email}
                    </Typography>
                  }
                />
              </ListItem>
              {index < candidates.length - 1 && <Divider component="li" className={styles.divider} />}
            </React.Fragment>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default NewCandidates;